var _path, _path2, _path3, _path4;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgPuzzle = function SvgPuzzle(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 115 114",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M114.668 53.733H91.019v5.41h18.269l-.015 49.624h5.395V53.733Zm-36.52 0v5.41H37.196v-5.41h40.952Zm-53.823 5.41H5.748v49.624H.338V53.733H24.326v5.41Z",
    fill: "#C5B27C"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M54.493.756h5.41v25.157h-5.41V.756Zm5.41 38.028h-5.41v39.782h5.41V38.784Zm-5.41 74.394V91.437h5.41v21.741h-5.41Z",
    fill: "#C5B27C"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M114.668.756H54.493v5.41h54.795l-.029 101.603H5.749V53.733H.338v59.445h114.329V.756Z",
    fill: "#C5B27C"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M75.224 54.58V38.199h18.72v16.38M55.332 41.709h-16.38V22.988h16.38M40.121 58.09v16.38H21.4V58.09M58.843 94.362h16.38V75.64h-16.38",
    stroke: "#C5B27C",
    strokeWidth: 5.85
  })));
};
export default SvgPuzzle;